import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "./reducers";

const middleware = [thunk];

const store = createStore(
  rootReducer,          // ✅ MUST BE rootReducer
  {},                   // initial state
  composeWithDevTools(applyMiddleware(...middleware))
);
// ✅ persist cart
 store.subscribe(() => { localStorage.setItem( "cart", JSON.stringify(store.getState().cart.cart) ); });


export default store;
